import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    "@keyframes animate": {
      from: {
        transform: " rotateY(0)",
      },
      to: {
        transform: " rotateY(180deg)",
      },
    },

    card: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "400px",
      height: "300px",
      margin: "-200px",
      float: "left",
      perspective: "500px",
    },

    content: {
      position: "absolute",
      width: "100%",
      height: "100%",
      boxShadow: "0 0 15px rgba(0,0,0,0.1)",

      transition: "transform 1s",
      transformStyle: "preserve-3d",
      animation: "$animate 1s ease-in forwards",
    },

    shared: {
      position: "absolute",
      height: "100%",
      width: "100%",
      background: "#133c89",
      color: "#FFF",
      lineHeight: "300px",
      textAlign: "center",
      fontSize: "60px",
      borderRadius: "5px",
      backfaceVisibility: "hidden",
    },

    back: {
      background: "#7F6944",
      color: "#FFF",
      transform: "rotateY( 180deg )",
    },
  };
});
